import { Dispatch } from 'redux';
import ActionType from '../actionTypes/onlineDesignerActionTypes';
import ApiEndpoints from '../ApiEndpoints';
import { handleRequest } from './helpers';
import { Fabric, ProductSchema } from '../../schemas/product';
import { SelectedSize } from '../../schemas/onlineDesigner';
import { IMember } from '../../components/TeamDialog/TeamDialog';

export const loadProduct = (
    idProduct: number,
    idLanguage: number,
    idCurrency: number
) => async (dispatch: Dispatch): Promise<{ errors: any } | null> => {
    const url = ApiEndpoints.GET_PRODUCT(idProduct, idLanguage, idCurrency);
    const actionTypes = ActionType.loadProduct;

    return handleRequest(url, dispatch, actionTypes, (data: any) => {
        return ProductSchema.parse(data);
    });
};

export const setSelectedFabric = (fabric: Fabric | null) => ({
    type: ActionType.selected.setFabric,
    fabric,
});

export const setSelectedSizes = (sizes: SelectedSize[] | null) => ({
    type: ActionType.selected.setSizes,
    sizes,
});

export const setMembers = (data: IMember[]) => ({
    type: ActionType.team.setMembers,
    data,
});
